<div class="wrapper" *ngIf="statusText" [ngClass]="theme">
  <mat-icon class="icon">{{icon}}</mat-icon><span class="text">{{statusText}}</span>
</div>
